type PlatformSessionIdsChangedListener = () => void

const listeners = new Set<PlatformSessionIdsChangedListener>()

export function onPlatformSessionIdsChanged(
  listener: PlatformSessionIdsChangedListener,
): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function notifyPlatformSessionIdsChanged(): void {
  for (const listener of listeners) {
    try {
      listener()
    } catch (error) {
      console.warn('[platformSessionSync] listener failed', error)
    }
  }
}
